import nvSharedModelsModule from '../../models/nv.shared.models.module';
import nvSorterColumnModule from '../../sorter-column/nv.sorterColumn.module';
import { AgGridFilterService } from './ag-grid-filter.service';

angular
  .module('nv.shared.services.sorter', [nvSorterColumnModule, 'nv.shared.services.sorter.agGrid', nvSharedModelsModule])
  .service('AgGridFilterService', AgGridFilterService);
